import Flex from '@dnb/eufemia/components/flex/Flex';
import { ApiType } from '@portals/shared/portal/ApiDto';
import { useOutletContext } from 'react-router-dom';

import { ApiProviderPageOutletContext } from '..';
import { AccessManagementSection } from './AccessManagementSection';
import ScopeRequestSection from './ScopeRequestSection/ScopeRequestSection';
import ScopesSection from './ScopeSection/ScopesSection';
import { VisibilityManagementSection } from './VisibilityManagementSection';

export function VisibilityAndAccessManagementTab() {
  const { api } = useOutletContext<ApiProviderPageOutletContext>();
  const isMcpApi = api.type === ApiType.MCP;

  return (
    <Flex.Stack gap="large" wrap={false}>
      <VisibilityManagementSection />
      {!isMcpApi && <AccessManagementSection />}
      {api.type === ApiType.REST && <ScopeRequestSection />}
      {!isMcpApi && <ScopesSection />}
    </Flex.Stack>
  );
}
